import { useState, useCallback, useEffect } from 'react';

/**
 * @param {number} offerStep maddenin mevcut step degerini (ana asamasini gosterir)
 * @param {boolean} canSeeAfterCopyright giris yapmis kullanicinin telif sonrasi asamalarini gormesi kosulunu kontrol eder
 * eger kullanici telif sonrasini gorme yetkisine sahip degilse kullanciya madde siparis ve telif surecindeki verilerle gosterilir
 */
function useHandleProcess({ offerStep, canSeeAfterCopyright }) {
  const [process, setProcess] = useState('1');

  const handleStep = (step) => {
    setProcess(step);
  };

  const handleProcess = useCallback(() => {
    const step = Number.parseInt(offerStep);
    switch (step) {
      case 'undefined':
        setProcess('1');
        break;
      case isNaN(step):
        setProcess('1');
        break;
      case 1:
        setProcess('1');
        break;
      case 3:
        setProcess('2');
        break;
      case 4:
        return canSeeAfterCopyright ? setProcess('3') : setProcess('2');
      case 5:
        setProcess('4');
        break;
      default:
        setProcess(step.toString());
        break;
    }
  }, [offerStep, canSeeAfterCopyright]);

  useEffect(() => {
    handleProcess();
  }, [handleProcess]);

  return { process, handleStep };
}

export default useHandleProcess;
